// extracted by mini-css-extract-plugin
export default {"root":"DetailsItem_root__V5kls"};